import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a58d945"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "t3" }, "Datos de facturación", -1))
const _hoisted_2 = { class: "wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_toast = _resolveComponent("toast")!
  const _component_InputError = _resolveComponent("InputError")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_toast),
    _hoisted_1,
    (!_ctx.allowedToEditForm)
      ? (_openBlock(), _createBlock(_component_InputError, {
          key: 0,
          error: _ctx.errorMessageForm
        }, null, 8, ["error"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        questions: _ctx.questions,
        rules: _ctx.rules,
        allowedToEditForm: _ctx.allowedToEditForm,
        buttonLabel: _ctx.buttonLabels,
        loadingSubmit: _ctx.loadingSubmit,
        onOnSubmit: _ctx.handleSubmit,
        onOnChange: _ctx.handleChange,
        onOnCancel: _ctx.handleCloseForm,
        onOnDeleteFile: _ctx.handleDeleteDefaultFile
      }, null, 8, ["questions", "rules", "allowedToEditForm", "buttonLabel", "loadingSubmit", "onOnSubmit", "onOnChange", "onOnCancel", "onOnDeleteFile"])
    ])
  ]))
}